import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Location } from '@/models/location.model';
import { ShiftCMSState } from '@/store';
import { LocationsActions, LocationsState } from '@/stores/locations.store';
import { ref, computed, onMounted, PropType, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationField',
  props: {
  label: {
    type: String,
  },
  modelValue: {
    type: Object as PropType<Location | undefined>,
    required: true,
  },
  required: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore<ShiftCMSState & { los: LocationsState }>();
const emit = __emit;

const location = ref<Location | undefined>(props.modelValue);

const locationItems = computed(() =>
  [...store.state.los.items]
    .sort((a, b) => (a.name > b.name ? -1 : 1))
    .map((c) => {
      return {
        title: `${c.name}`,
        value: c,
      };
    }),
);

function update(v: Location) {
  emit('update:modelValue', v);
  emit('change');
}

watch(
  () => props.modelValue,
  () => {
    location.value = props.modelValue;
  },
  { deep: true },
);

onMounted(() => {
  store.dispatch(LocationsActions.GetLocations);
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_autocomplete, {
      label: props.label ? props.label : 'Location',
      modelValue: location.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((location).value = $event)),
        update
      ],
      items: locationItems.value,
      chips: "",
      disabled: __props.disabled,
      multiple: false,
      valueComparator: (a, b) => a.id === b.id
    }, {
      item: _withCtx(({ props }) => [
        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_title)
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["label", "modelValue", "items", "disabled", "valueComparator"]),
    _createVNode(_component_v_container, { style: {"padding-top":"0","padding-bottom":"0"} }, {
      default: _withCtx(() => [
        (!location.value && __props.required)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              type: "warning",
              density: "compact"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("This is required")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})